import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/cartes-bancaires.png")